// The employee portal (time book, roster, overtime) is this same dashboard
// build on its own subdomain, like the operator platform: on a portal host
// index.tsx renders PortalRoutes. PORTAL_HOSTS (comma-separated, injected into
// index.html) lists exact hostnames; when unset, any "portal." host counts —
// portal.maxcei.pt in production, portal.localhost locally.
export const isPortalHost = (
  hostname: string = window.location.hostname,
  configuredHosts: string | undefined = window.__SALEOR_CONFIG__?.PORTAL_HOSTS,
): boolean => {
  const hosts = (configuredHosts ?? "")
    .split(",")
    .map(host => host.trim().toLowerCase())
    .filter(host => host && !host.startsWith("<%"));

  if (hosts.length > 0) {
    return hosts.includes(hostname.toLowerCase());
  }

  return hostname.toLowerCase().startsWith("portal.");
};
